import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";
import { useMemo } from "react";

import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ProductBundleAddToCartButtonComponentProps = {
    cart?: CartModel | null;
    bundleSkus: Array<string>;
    onAddToCart: () => void;
    addToCartLoading: boolean;
};

const ProductBundleAddToCartButtonComponent = ({
    cart,
    onAddToCart,
    addToCartLoading,
    bundleSkus
}: ProductBundleAddToCartButtonComponentProps) => {
    const { t } = useGranite();
    const bundleInCart = useMemo(
        () =>
            bundleSkus.every((bundleSku) =>
                cart?.items.find((cartItem) => cartItem.sku === bundleSku)
            ),
        [cart?.items, bundleSkus]
    );

    return (
        <Button
            type={"button"}
            color={"primary"}
            disabled={bundleInCart || addToCartLoading}
            outline={bundleInCart}
            onClick={onAddToCart}
        >
            <i
                className={classnames("las la-lg d-md-none", {
                    "la-plus": !bundleInCart && !addToCartLoading,
                    "la-check": bundleInCart && !addToCartLoading,
                    "la-spinner la-pulse": addToCartLoading
                })}
            ></i>
            <i className="las la-lg la-shopping-cart d-md-none"></i>
            <span className="d-none d-md-inline-block">
                {t("ecommerce.button.order")}{" "}
                <i className="la-md las la-angle-right"></i>
            </span>
        </Button>
    );
};

export { ProductBundleAddToCartButtonComponent };
